import * as React from "react";
const SvgFiRrRadish = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-radish_svg__a)">
      <path
        fill="#062147"
        d="M22.335 8c4.95-4.354-1.972-11.273-6.322-6.322C14.128-1.3 9.263-.006 9.035 3.507c-.027 3.1 1.88 4 1.956 7.6-2.931-2.486-6.725-3.024-9.527-.158-2 1.916-1.292 6.49-1.45 9.035a4.02 4.02 0 0 0 4 4.016c2.54-.156 7.147.567 9.063-1.428 2.649-2.652 2.547-6.225-.17-9.546 3.562.068 4.56 2 7.6 1.958 3.506-.208 4.815-5.106 1.828-6.984m-2.82-6a2.517 2.517 0 0 1 1.768 4.267c-.325.326-1.65 1.094-2.135 1.438-1.591.875-3.662 1.8-5.335 2.5.7-1.672 1.62-3.741 2.495-5.333C17.1 3.428 17.9 2 19.515 2m-6.494.006a1.844 1.844 0 0 1 1.669 1.667 50 50 0 0 0-2.176 4.472c-.392-1.7-1.533-2.958-1.487-4.463a1.844 1.844 0 0 1 1.994-1.676m-1.358 19.152c-1.175 1.264-5.883.712-7.65.842-2.673-.163-1.885-3-1.98-5.088 0-1.908.006-3.71.845-4.55 2.466-2.447 5.334-1.29 7.705 1.065 1.323 1.324 4.077 4.729 1.08 7.73m9.92-8.817c-1.7 1.717-3.638-.432-5.71-.838a50 50 0 0 0 4.468-2.175 1.85 1.85 0 0 1 1.243 3.013"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-radish_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRadish;
